export const ANDROID_NOTIFICATIONS_SETTINGS_URL = 'https://support.google.com/android/answer/9079661';
export const IOS_NOTIFICATIONS_SETTINGS_URL = 'https://support.apple.com/108781';

export enum NOTIFICATION_PERMISSION {
  GRANTED = 'granted',
  DENIED = 'denied',
  DEFAULT = 'default',
}

export const OneDayInMilliseconds = 24 * 60 * 60 * 1000;
